.overlay {
  z-index: var(--h5w-zi-tooltip);
}

.tooltip {
  padding: 0.25rem 0.5rem;
  background-color: var(--h5w-tooltip--bgColor, rgba(255, 255, 255, 0.9));
  border-radius: 0.25rem;
  box-shadow: rgba(33, 33, 33, 0.2) 0px 1px 2px;
  color: var(--h5w-tooltip--color, inherit);
  font-family: var(--h5w-tooltip--fontFamily, inherit);
  font-size: var(--h5w-tooltip--fontSize, 0.75em);
  user-select: none;
}
